import SideMenu from '@/containers/side-menu/SideMenu.vue';
import CloseAccountingCashInfo from '@/pages/closed-accounting-info/ClosedAccountingInfo.vue';

export default {
  path: '/accounting-cash-report/:accountingId',
  name: 'CloseAccountingCashInfo',
  components: {
    mainContent: CloseAccountingCashInfo,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'accounting-cash-report',
    },
    breadcrumb: {
      title: 'Controle de caixa',
      paths: [{ title: 'Controle de caixa' }, { title: 'Relatório' }],
    },
  },
};
